import React, {
  useState,
  FunctionComponent,
  useEffect,
  useCallback,
} from 'react';
import styled, { css, keyframes } from 'styled-components';
import { RenderImageProps } from 'react-photo-gallery';

type StyledType = {
  photo?: {
    src: string;
    srcSet?: string | string[] | undefined;
    sizes?: string | string[] | undefined;
    width: number;
    height: number;
    alt?: string | undefined;
    key?: string | undefined;
  };
  isAfterFirstRender?: boolean;
  isOpen?: boolean;
  leftPixel?: number;
  isEmptyImage?: boolean;
};

const ImageItemComponent = styled.div`
  margin: 3px;
  ${(props: StyledType) => {
    if (props.photo) {
      return css`
        width: ${props.photo.width}px;
      `;
    }
    return css``;
  }}
  ${(props: StyledType) => {
    if (props.isOpen) {
      return css`
        background-color: #e8f0fe;
        border-radius: 6px;
        border: 1px solid;
        border-color: #4285f4;

        /* width: 100%; */

        opacity: 0.5;
      `;
    }
    return css``;
  }}
`;

const ThumbnailBox = styled.div`
  position: relative;
  background-color: '#eee';
  overflow: hidden;

  border-radius: 6px;
  ${(props: StyledType) => {
    if (props.photo) {
      return css`
        /* max-width: 100%;
      height: 200px; */
        height: ${props.photo.height}px;
        width: ${props.photo.width}px;
      `;
    }

    return css``;
  }}
  ${(props: StyledType) => {
    if (props.isEmptyImage) {
      return css``;
    }
    return css`
      /* cursor: pointer; */
    `;
  }}
`;

const ThumbnailImage = styled.img`
  /* max-width: 100%;
  height: 200px; */
  /* transition: 'transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s'; */
  /* border-radius: 6px; */
`;
const ImageScore = styled.div`
  font-family: 'NotoKrR';
  font-size: 12px;
  padding: 5px;
  position: absolute;
  border-radius: 6px;
  right: 0;
  bottom: 0;
  background-color: white;
  opacity: 0.5;
`;
const ThumbnailTitle = styled.div`
  width: inherit;
  font-family: 'NotoKrR';
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  em {
    font-family: 'NotoKrM';
    font-style: normal;
  }
`;
const ThumbnailSource = styled.div`
  font-family: 'NotoKrR';
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

interface ImageItemProps
  extends RenderImageProps<{
    id?: string;
    url?: string;
    src: string;
    width: number;
    height: number;
    targetId?: number;
    alt?: string | undefined;
    title?: string;
    desc?: string;
    source?: string;
  }> {
  toggleModal: () => void;
  //   onSetSelectPhotoData: (
  //     selectPhotoData: tabImageState['selectPhotoData']
  //   ) => void;
  //   onSetIsDetailViewOpen: (
  //     isDetailViewOpen: tabImageState['isDetailViewOpen']
  //   ) => void;
  //   selectPhotoData: tabImageState['selectPhotoData'];
}

const ImageItem: FunctionComponent<ImageItemProps> = ({
  index,
  photo,
  direction,
  top,
  left,
  toggleModal,
}: ImageItemProps) => {
  return (
    <ImageItemComponent photo={photo}>
      {photo.src === '' ? (
        <ThumbnailBox photo={photo} isEmptyImage />
      ) : (
        <ThumbnailBox photo={photo} isEmptyImage={false}>
          <ThumbnailImage
            alt=""
            src={photo.src}
            width={photo.width}
            height={photo.height}
            // onClick={() => {
            //   toggleModal();
            // }}
          />
          <ImageScore>유사도 {photo.source}</ImageScore>
        </ThumbnailBox>
      )}

      {/* {photo.title ? (
        <ThumbnailTitle
          dangerouslySetInnerHTML={{
            __html: photo.title,
          }}
        />
      ) : null}

      <ThumbnailSource>{photo.source}</ThumbnailSource> */}
    </ImageItemComponent>
  );
};

export default ImageItem;
